module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABHSURBVHgB7c5BFcAgDAPQUCV11EqYs1nYnOAAJy0FC3CC/kNyywuQ0oHKCBF5oxiLzOwvqsru3rBHnQ9j9Il1xiIi+pAu0AE5khA3ZRYPUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/minus-icon-checked.png
// module id = 312
// module chunks = 1